import { useResizeObserver } from '@vueuse/core'

export const EMBED_HEIGHT_MESSAGE_TYPE = 'dubb-form-height'

/**
 * Posts the document height to the parent window whenever it changes,
 * so the page embedding this iframe can size it to fit.
 */
export function useEmbedHeight(target: Window = window) {
  if (target.parent === target) {
    return
  }

  // the body's own box, not documentElement.scrollHeight, which never drops below the iframe viewport
  useResizeObserver(target.document.body, ([entry]) => {
    target.parent.postMessage({
      type: EMBED_HEIGHT_MESSAGE_TYPE,
      height: Math.ceil(entry.contentRect.height),
    }, '*')
  })
}
